import React, { useMemo } from "react";
import { Percent } from "lucide-react";

import { Input } from "../../../../components/ui/input";
import { Slider } from "../../../../components/ui/slider";

import { piso, reais } from "../formato";
import Bloco from "./Bloco";
import { produtoExemplo } from "./exemplo";

export default function SecaoDesconto({ config, produtos, onMudar }) {
  const pct = Number(config.desconto_max_padrao_pct) || 0;
  const exemplo = useMemo(() => produtoExemplo(produtos, config), [produtos, config]);
  const preco = Number(exemplo?.preco || 0);
  const minimo = piso(preco, Math.floor(pct));
  const mudarPct = (v) => onMudar("desconto_max_padrao_pct", v === "" ? "" : Math.min(90, Math.max(1, Number(v))));

  return (
    <Bloco icone={Percent} titulo="Tamanho do desconto"
      subtitulo="O sorteio escolhe de 1% até o máximo. Produto com porcentagem própria na aba Produtos segue a dele.">
      <div data-e2e="desconto-padrao">
        <div className="flex items-center justify-between gap-3 mb-3">
          <p className="text-sm font-semibold">Desconto máximo</p>
          <div className="flex items-center gap-1">
            <Input type="number" min={1} max={90} value={config.desconto_max_padrao_pct ?? ""} className="w-20 h-9 text-right font-bold"
              onChange={(e) => mudarPct(e.target.value)} aria-label="Desconto máximo em %" />
            <span className="text-sm text-muted-foreground">%</span>
          </div>
        </div>
        <Slider value={[Math.min(90, Math.max(1, pct || 1))]} min={1} max={90} step={1} onValueChange={([v]) => mudarPct(v)} aria-label="Desconto máximo" />
        <div className="flex justify-between text-[11px] text-muted-foreground mt-1.5"><span>1%</span><span>90%</span></div>
        {exemplo && pct > 0 && (
          <div className="mt-4 rounded-xl bg-muted/50 p-3" data-e2e="exemplo-desconto">
            <p className="text-xs text-muted-foreground">
              Exemplo com <b className="text-foreground">{exemplo.name}</b>, que custa {reais(preco)}:
            </p>
            <div className="relative h-2 rounded-full bg-gradient-to-r from-emerald-500 to-amber-500 mt-3" />
            <div className="flex justify-between mt-1.5 text-xs">
              <span><span className="text-muted-foreground">com 1%</span> <b>{reais(piso(preco, 1))}</b></span>
              <span><span className="text-muted-foreground">com {Math.floor(pct)}%</span> <b>{reais(minimo)}</b></span>
            </div>
            <p className="text-xs mt-2">O cliente nunca paga menos que <b className="text-emerald-600 dark:text-emerald-400">{reais(minimo)}</b> nesse produto.</p>
          </div>
        )}
      </div>
    </Bloco>
  );
}
